import { CurationItem } from "../../types";
import { createMenuContainer, getRequiredPublisherId, updateMenuContainer } from "./helpers";

/**
 * Creates a new menu
 * @param parentId
 * @param title
 * @param layoutPosition
 * @returns {Promise<CurationItem>}
 */
export const createMenu = async (
    parentId: string,
    title: string,
    layoutPosition: "Header" | "Footer",
): Promise<CurationItem> => {
    if (!parentId || !title || !layoutPosition) {
        throw new Error("createMenu requires a parentId, title, and layoutPosition.");
    }

    const publisherId = getRequiredPublisherId();
    const newMenu = await createMenuContainer(parentId, publisherId, "Menu");

    const updateBody: CurationItem = {
        ...newMenu,
        title,
        metadata: {
            ...newMenu.metadata,
            default: {
                ...newMenu.metadata.default,
                "layout-menu-position": layoutPosition,
            },
            en_US: {
                ...newMenu.metadata.en_US,
                title,
            },
        },
    };

    await updateMenuContainer(newMenu.id, updateBody, "Menu");

    return newMenu;
};
